"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const native_base_1 = require("native-base");
const react_1 = require("react");
const colors_1 = require("../../common/colors");
const theme_1 = require("../../helper/theme");
const AppText_1 = require("../AppText");
const CharacterImageWarn = (props) => {
    return ((0, jsx_runtime_1.jsxs)(native_base_1.HStack, { width: "100%", alignSelf: "center", padding: 2, space: 2, py: 3, borderWidth: 1, bg: "#1A1A1F", borderColor: "#2A2A2F", borderRadius: 5, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faDiamondExclamation, size: 16, color: props?.color || colors_1.Colors.white }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: props?.color || colors_1.Colors.DARK_100, textAlign: "left", alignSelf: "center", paddingRight: 6, fontSize: (0, theme_1.normalize)(11), fontWeight: 400, allowFontScaling: false, children: props?.message ||
                    "Observe copyright laws and honor the rights of fellow creators." })] }));
};
exports.default = (0, react_1.memo)(CharacterImageWarn);
